import { TFactoryMetaDataDTO, TRESPONSE_TNA_TEMPLATE_LISTING, TTnaTemplateDTO } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export const TNA_TEMPLATES_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_TNA_TEMPLATE_LISTING['templates'],
    factories: TFactoryMetaDataDTO[] = [],
    buyers: string[] = [],
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select: {
          position: 'START',
          isMulti: false,
          size: 'DEFAULT',
        },
        edit: {
          hasAddRow: false,
          hasDeleteRow: true,
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'ID',
            isHidden: true,
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value: TTnaTemplateDTO) => value.templateId,
              },
              metadata: {
                keyName: 'templateId',
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'TEMPLATE NAME',
            widthInPx: 200,
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value: TTnaTemplateDTO) => value.name,
                placeholder: 'Enter template name',
              },
              metadata: {
                keyName: 'updatedName',
                isRequired: true,
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'STATUS',
            widthInPx: 200,
            align: 'center',
          },
          {
            type: 'TEXT_CELL',
            text: 'FACTORY NAME',
            widthInPx: 200,
            liftedInput: {
              input: {
                type: 'DROPDOWN',
                isMulti: true,
                options: factories.map((factory) => ({ value: factory.id, displayName: factory.name })),
                setValue: (value: TTnaTemplateDTO) => (value.factories || []).map((factory) => factory.id),
                placeholder: 'Select factory',
              },
              metadata: {
                keyName: 'factories',
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'BUYER NAME',
            widthInPx: 200,
            liftedInput: {
              input: {
                type: 'DROPDOWN',
                isMulti: true,
                options: buyers.map((buyer) => ({ value: buyer, displayName: buyer })),
                setValue: (value: TTnaTemplateDTO) => value.buyerNames || [],
                placeholder: 'Select buyer',
              },
              metadata: {
                keyName: 'buyers',
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'DURATION IN DAYS',
            widthInPx: 200,
            align: 'center',
          },
          {
            type: 'ACTION_CELL',
            actionType: 'COPY',
            widthInPx: 200,
            align: 'right',
            asIcon: true,
          },
        ],
      },
      (item): TTableRowNode<TTnaTemplateDTO> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.templateId || '',
            },
            {
              type: 'TEXT_CELL',
              text: item.name,
              href: '/tna/tna-details',
              queryParams: { templateName: item.name, templateId: item.templateId },
              navigationState: { factoryNames: item.factoryNames, buyerNames: item.buyerNames },
            },
            {
              type: 'TEXT_CELL',
              text: '',
              align: 'center',
              tag: {
                tagContent: item.status,
                tagBgColor: item.status === 'Complete' ? 'green' : 'yellow',
              },
            },
            {
              type: 'TEXT_CELL',
              text: item.factoryNames?.length ? item.factoryNames.join(', ') : '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.buyerNames?.length ? item.buyerNames.join(', ') : '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.criticalPathDurationInDays ?? '--',
              align: 'center',
            },
            {
              type: 'ACTION_CELL',
              actionType: 'COPY',
              asIcon: true,
              align: 'right',
              showLargeIcon: true,
            },
          ],
        };
      },
    );
  },
};
